import { CreatorsToActions } from '../helper'

type Actions = CreatorsToActions<typeof import('../actions/dialog')>

interface State {
  isShow: boolean
  title: string
  content: string
  okHandler: () => void
  ngHandler: () => void
  noCancel?: boolean
}
// ______________________________________________________
//
export function initialState(injects?: State): State {
  return {
    isShow: false,
    title: '',
    content: '',
    okHandler: () => {},
    ngHandler: () => {},
    noCancel: false
  }
}
// ______________________________________________________
//
export function reducer(state = initialState(), action: Actions): State {
  switch (action.type) {
    case 'SET_DIALOG':
      return {
        isShow: true,
        title: action.payload.title,
        content: action.payload.content,
        okHandler: action.payload.okHandler,
        ngHandler: action.payload.ngHandler,
        noCancel: action.payload.noCancel
      }
    case 'UNSET_DIALOG':
      return {
        isShow: false,
        title: '',
        content: '',
        okHandler: () => {},
        ngHandler: () => {},
        noCancel: false
      }
    default:
      return state
  }
}
